import React, { useState } from "react";

import {
  Backdrop,
  CircularProgress,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";

import {
  Edit,
  FormTab,
  Loading,
  TabbedForm,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { BackButton } from "../../../../components/common/BackButton";
import { ForceTitle } from "../../../../components/common/ForceTitle";
import { HelpButton } from "../../../../components/common/HelpButton";
import { HistoryTab } from "../../../../components/common/HistoryTab";
import { getBackPath } from "../../../../utils/utils";

import { ChargeRuleForm } from "./ChargeRuleForm";
import { validateChargeRuleForm } from "./ChargeRuleCreate";
import { DeepDeleteButton } from "./DeepDeleteButton";
import { DialogSaveButton } from "./DialogSaveButton";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const EditActions = ({ backPath, ...props }) => (
  <TopToolbar>
    <HelpButton>
      <div>
        <h3>Charge Rule Help</h3>
        <p>Edit an existing charge rule for this account.</p>
        <p>Charge rules define when and how to bill customers for services.</p>
      </div>
    </HelpButton>
    <BackButton {...props} backPath={backPath} />
  </TopToolbar>
);

const EditToolbar = ({ account, backPath, ...props }) => {
  const classes = useStyles();
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  return (
    <Toolbar style={{ justifyContent: "space-between" }}>
      <Backdrop className={classes.backdrop} open={isSaving || isDeleting}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DialogSaveButton
        {...props}
        label="Save"
        backPath={backPath}
        isDeleting={isDeleting}
        isSaving={isSaving}
        setIsSaving={setIsSaving}
      />
      <DeepDeleteButton
        {...props}
        backPath={backPath}
        isDeleting={isDeleting}
        setIsDeleting={setIsDeleting}
        isSaving={isSaving}
      />
    </Toolbar>
  );
};

export const ChargeRuleEdit = (props) => {
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const backPath = getBackPath(props);
  const account = props.location?.state?.account;
  const allChargeRules = props.location?.state?.allChargeRules;

  if (!account) return <Loading />;
  return (
    <Edit
      {...props}
      title={<ForceTitle title="Edit Charge Rule" />}
      mutationMode="pessimistic"
      actions={<EditActions backPath={backPath} />}
    >
      <TabbedForm
        variant="outlined"
        validate={(record) => validateChargeRuleForm(record, allChargeRules)}
        toolbar={
          <EditToolbar {...props} account={account} backPath={backPath} />
        }
      >
        <FormTab label="Rule Settings">
          <ChargeRuleForm account={account} allChargeRules={allChargeRules} />
        </FormTab>
        {mdUp && (
          <FormTab path="historyLog" label="History Log">
            <HistoryTab />
          </FormTab>
        )}
      </TabbedForm>
    </Edit>
  );
};
